<template>
  <div class="common-card" :key="routeKey">
    <modal-filter
      :filter_user_id.sync="filter_user_id"
      :filter_claim_status_id.sync="filter_claim_status_id"
      :filter_invoice_id.sync="filter_invoice_id"
      :filter_start_date.sync="filter_start_date"
      :filter_end_date.sync="filter_end_date"
      :filter_min_amount.sync="filter_min_amount"
      :filter_max_amount.sync="filter_max_amount"
      :is_user_page="is_user_page"
      :userOptions="userOptions"
      :claimStatusOptions="claimStatusOptions"
      :invoiceOptions="invoiceOptions"
      @refetch-data="refetchData"
    />
    <modal-status
      :claim-data="claimData"
      :claimStatusOptions="claimStatusOptions"
      @refetch-data="refetchData"
    />
    <modal-approval :approve-data="approveData" @refetch-data="refetchData" />

    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <font-awesome-icon
              class="mr-50"
              icon="fa-solid fa-money-check-dollar"
            />
            報銷記錄
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
            <b-form-input
              v-model="searchQuery"
              class="search-form mb-1 mb-sm-0 ml-sm-1"
              placeholder="搜尋記錄"
            />
          </div>
        </div>
        <div class="d-flex flex-wrap mobile-w100 mt-1 mt-lg-0">
          <b-button
            variant="primary"
            class="mobile-w100 mb-1 mb-sm-0 mr-sm-1"
            @click="$bvModal.show('modal-filter')"
            ><feather-icon
              class="mr-1"
              icon="filterIcon"
              size="18"
            ></feather-icon
            >篩選</b-button
          >
          <!-- 匯出功能按鈕 -->
          <b-dropdown
            v-if="ability.can('export', 'user_claims') && is_user_page || ability.can('export', 'claims') && !is_user_page"
            variant="success"
            text="匯出"
            class="mobile-w100 mb-1 mb-sm-0 mr-sm-1"
            :disabled="isExporting"
          >
            <template #button-content>
              <b-spinner
                v-if="isExporting"
                small
                class="mr-1"
              ></b-spinner>
              <feather-icon
                v-else
                size="16"
                class="mr-1"
                icon="DownloadIcon"
              />
              {{ isExporting ? '匯出中...' : '匯出' }}
            </template>
            <b-dropdown-item
              @click="exportCurrentPage"
              :disabled="isExporting"
            >
              <feather-icon size="16" class="mr-1" icon="FileTextIcon" />
              匯出此頁面
            </b-dropdown-item>
            <b-dropdown-item
              @click="exportAllRecords"
              :disabled="isExporting"
            >
              <feather-icon size="16" class="mr-1" icon="DatabaseIcon" />
              匯出全部記錄
            </b-dropdown-item>
          </b-dropdown>
          <b-button
            class="mobile-w100"
            :to="{ name: 'worker-claim-create', query: { user_id: user_id } }"
            v-if="ability.can('create', 'user_claims') && is_user_page"
          >
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增記錄</b-button
          >
          <b-button
            class="mobile-w100"
            :to="{ name: 'claim-create' }"
            v-if="ability.can('create', 'claims') && !is_user_page"
          >
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增記錄</b-button
          >
        </div>
      </div>
    </b-card>
    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refClaimListTable"
          class="position-relative"
          :items="fetchClaims"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- <template #cell(id)="data">
              {{ data.item.claim_number}}
          </template> -->

          <!-- <template #cell(is_approved)="data">
            <feather-icon
              v-if="data.item.is_approved"
              icon="CheckIcon"
              size="18"
              class="mr-50 text-success"
            />
          </template> -->
          <template #cell(purpose)="data">
            {{ data.item.purpose ? data.item.purpose : '- -' }}
          </template>

          <!-- <template #cell(requires_invoice)="data">
            <b-badge
              :variant="data.item.requires_invoice ? 'success' : 'secondary'"
              class="text-capitalize"
            >
              {{ data.item.requires_invoice ? '需要發票' : '不需要發票' }}
            </b-badge>
          </template> -->

          <template #cell(invoice_info)="data">
            <a
              :href="
                $router.resolve({
                  name: 'invoice-edit',
                  params: { id: data.item.invoice_id },
                }).href
              "
              target="_blank"
              class="text-primary"
              v-if="data.item.invoice"
            >
              [{{ data.item.invoice.invoice_number }}]
              {{ data.item.invoice.name_cn || "未指定客戶" }}
            </a>
            <div v-else class="text-muted">無報銷發票</div>
          </template>

          <template #cell(total_amount)="data">
            ${{
              data.item.total_amount
                ? Number(data.item.total_amount).toFixed(2)
                : "0.00"
            }}
          </template>

          <template #cell(payment_method)="data">
            <div class="row mb-50">
              <!-- <b class="label">付款方式：</b> -->
              <span>{{
                data.item.payment_method
                  ? data.item.payment_method.name
                  : "未設定"
              }}</span>
              <span
                v-if="
                  data.item.payment_method_id == 1 && data.item.check_number
                "
              >
                {{ data.item.check_number }}
              </span>
            </div>
          </template>

          <template #cell(claim_status)="data">
            <a
              v-if="
                ability.can('status', 'claims') ||
                ability.can('status', 'user_claims')
              "
              href="javascript:void(0)"
              @click="handleStatus(data.item)"
              class="d-flex align-items-center"
            >
              <feather-icon class="mr-25" icon="EditIcon" />
              {{ getClaimStatus(data.item.claim_status_id) }}
            </a>
            <div v-else>
              {{ getClaimStatus(data.item.claim_status_id) }}
            </div>
          </template>

          <!-- Column: expense_items -->
          <template #cell(show_details)="row">
            <b-button
              v-if="row.item.expense_items"
              size="sm"
              @click="row.toggleDetails()"
              class="mr-2"
            >
              {{ row.detailsShowing ? "隱藏" : "顯示" }}
            </b-button>
            <span v-else>- -</span>
          </template>

          <template #row-details="row">
            <div class="info-container">
              <b-row
                class="p-2 backgroundColor3 mb-1"
                v-for="(claim, index) in row.item.expense_items"
                :key="`claim${index}`"
              >
                <b-col cols="12">
                  <div class="row mb-50">
                    <b class="label">代購分類：</b>
                    <span>{{
                      getPurchaseCategory(claim.purchase_category_id)
                    }}</span>
                  </div>

                  <div class="row mb-50">
                    <b class="label">代購內容：</b>
                    <span>{{ claim.remark || "無" }}</span>
                  </div>
                  <div class="row mb-50">
                    <b class="label">金額：</b>
                    <span>${{ claim.total }}</span>
                  </div>
                </b-col>
              </b-row>
            </div>
          </template>

          <template #cell(created_at)="data">
            {{ getDateTime(data.item.created_at) }}
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                claimsList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="ability.can('update', 'user_claims') && is_user_page"
                :to="{
                  name: 'worker-claim-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('update', 'claims') && !is_user_page"
                :to="{
                  name: 'claim-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <!-- <b-dropdown-item
                v-if="
                  ability.can('approve', 'claims') ||
                  ability.can('approve', 'user_claims')
                "
                @click="handleApproval(data.item)"
              >
                <feather-icon icon="CheckIcon" />
                <span class="align-middle ml-50">更新批核狀態</span>
              </b-dropdown-item> -->
               <b-dropdown-item
                v-if="
                  ability.can('status', 'claims') ||
                  ability.can('status', 'user_claims')
                "
                @click="handleStatus(data.item)"
              >
                <feather-icon icon="CheckIcon" />
                <span class="align-middle ml-50">更新報銷狀態</span>
              </b-dropdown-item> 

              <b-dropdown-item
                v-if="
                  ability.can('delete', 'claims') ||
                  ability.can('delete', 'user_claims')
                "
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除記錄</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useClaimsList from "./useClaimsList";
import claimStoreModule from "../claimStoreModule";
import ModalFilter from "../modal/ModalFilter";
import ModalApproval from "../modal/ModalApproval";
import ModalStatus from "../modal/ModalStatus";
import { getUserData } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    vSelect,
    ModalFilter,
    ModalApproval,
    ModalStatus,
  },
  data() {
    return {
      approveData: null,
      claimData: null,
      user_id: getUserData().id,
      isExporting: false,
    };
  },
  props: {
    routeKey: String,
  },
  methods: {
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("claims/deleteClaim", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    handleStatus(item) {
      this.claimData = item;
      this.$bvModal.show("modal-status");
    },
    handleApproval(item) {
      this.approveData = item;
      this.$bvModal.show("modal-approval");
    },

    getClaimStatus(statusId) {
      if (
        !statusId ||
        !this.claimStatusOptions ||
        !this.claimStatusOptions.length
      )
        return "";
      const status = this.claimStatusOptions.find((ele) => ele.id === statusId);
      return status ? status.name : "";
    },    // 匯出此頁面
    exportCurrentPage() {
      if (this.isExporting) return;

      this.isExporting = true;
      this.exportRecords('current')
        .then(exportData => {
          this.downloadExcel(exportData, '報銷記錄_當前頁面');
        })
        .catch(error => {
          console.error('匯出當前頁面失敗:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "匯出失敗",
              text: "匯出當前頁面失敗，請稍後再試",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.isExporting = false;
        });
    },

    // 匯出全部記錄
    exportAllRecords() {
      if (this.isExporting) return;

      this.isExporting = true;
      this.exportRecords('all')
        .then(exportData => {
          this.downloadExcel(exportData, '報銷記錄_全部記錄');
        })
        .catch(error => {
          console.error('匯出全部記錄失敗:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "匯出失敗",
              text: "匯出全部記錄失敗，請稍後再試",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.isExporting = false;
        });
    },

    // 下載 Excel 文件
    downloadExcel(data, filename) {
      if (!data || data.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "匯出失敗",
            text: "沒有數據可以匯出",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      // 計算實際記錄數量
      const actualRecordCount = data.length;

      // 匯出為 Excel (使用 ExcelJS 支援完整樣式)
      import("@/utils/excelExport").then(async (excelExport) => {
        try {
          // 使用專業級的報銷記錄匯出函數
          const success = await excelExport.export_claims_to_excel_styled({
            title: '報銷記錄',
            data: data,
            filename: filename,
            bookType: 'xlsx'
          });

          if (success) {
            // 顯示成功訊息
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "匯出成功",
                text: `已成功匯出 ${actualRecordCount} 筆記錄，檔案包含完整的格式化樣式`,
                icon: "CheckCircleIcon",
                variant: "success",
              },
            });
          } else {
            throw new Error('匯出過程中發生錯誤');
          }
        } catch (error) {
          console.error('Excel 匯出失敗:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "匯出失敗",
              text: "Excel 匯出過程中發生錯誤，請稍後再試",
              icon: "XCircleIcon",
              variant: "danger",
            },
          });
        }
      }).catch((error) => {
        console.error('匯出失敗:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "匯出失敗",
            text: "Excel 匯出功能載入失敗",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "claims";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, claimStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const getPurchaseCategory = (id) => {
      const categories = {
        1: "工具/五金用品",
        2: "運輸(叫車)",
      };
      return categories[id] || "未知分類";
    };

    const getApprove = (id) => {
      if (
        !id ||
        !claimStatusOptions.value ||
        !claimStatusOptions.value.length
      ) {
        return {};
      }
      const status = claimStatusOptions.value.find((ele) => ele.id === id);
      return status || {};
    };

    const {
      fetchClaims,
      tableColumns,
      perPage,
      totalRow,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      dataMeta,
      claimsList,
      refClaimListTable,
      ability,
      refetchData,
      filter_user_id,
      filter_claim_status_id,
      filter_invoice_id,
      filter_start_date,
      filter_end_date,
      filter_min_amount,
      filter_max_amount,
      userOptions,
      claimStatusOptions,
      invoiceOptions,
      is_user_page,
      exportRecords,
    } = useClaimsList();

    return {
      fetchClaims,
      tableColumns,
      perPage,
      totalRow,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      dataMeta,
      claimsList,
      refClaimListTable,
      ability,
      refetchData,
      filter_user_id,
      filter_claim_status_id,
      filter_invoice_id,
      filter_start_date,
      filter_end_date,
      filter_min_amount,
      filter_max_amount,
      userOptions,
      claimStatusOptions,
      invoiceOptions,
      getPurchaseCategory,
      getApprove,
      is_user_page,
      exportRecords,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
